import React from "react";
import { Link, useLocation } from "react-router-dom";

const Sidebar = ({ isOpen }) => {
  const location = useLocation();

  const menuItems = [
    { path: "/admin/all-complaint", label: "الرئيسية", icon: "bi-house" },
    { path: "/admin/establishments", label: "إدارة الفعاليات", icon: "bi-building" },
    { path: "/admin/users-management", label: "إدارة المستخدمين", icon: "bi-people" },
    { path: "/admin/permissions-management", label: "إدارة الصلاحيات", icon: "bi-shield-lock" },
    { path: "/admin/roles-management", label: "إدارة الأدوار", icon: "bi-person-badge" },
    { path: "/admin/activities-management", label: "إدارة النشاطات", icon: "bi-activity" },
    { path: "/admin/facilitytypes-management", label: "نوع الفعالية", icon: "bi-tag" },
    { path: "/admin/patrolstaff-management", label: "إدارة الموظفين", icon: "bi-person-workspace" },
    { path: "/admin/violation-types-management", label: "أنواع الضبوط", icon: "bi-exclamation-octagon" },
    { path: "/admin/sales-types-management", label: "أنواع البيع", icon: "bi-cart" },
    { path: "/admin/patrol-rosters", label: "ادارة الدوريات", icon: "bi-plus-circle" },
    { path: "/admin/inspection-mission/create", label: "اسناد المهام", icon: "bi-plus-circle" },
    { path: "/admin/price-survey-products", label: "المواد", icon: "bi-plus-circle" },

  ];

  return (
    <div
      className="bg-dark vh-100 position-fixed p-0 shadow"
      style={{
        width: "250px", // تقليل العرض قليلاً
        right: isOpen ? "0" : "-250px",
        transition: "right 0.3s ease-in-out",
        zIndex: 1000,
        overflowY: "auto",
        direction: "rtl",
        borderLeft: "1px solid rgba(255,255,255,0.05)"
      }}
    >
      <div className="p-3 mb-1 mt-2">
        <h6 className="text-info fw-bold m-0 opacity-75" style={{ letterSpacing: "0.5px" }}>القائمة الرئيسية</h6>
      </div>

      <ul className="nav flex-column px-2">
        {menuItems.map((item, index) => {
          const isActive = location.pathname === item.path;

          return (
            <li className="nav-item mb-1" key={index}>
              <Link
                to={item.path}
                className={`nav-link d-flex align-items-center position-relative py-2 px-3 transition-all ${isActive ? "active-link" : "text-light opacity-50"
                  } custom-hover`}
                style={{
                  textDecoration: "none",
                  borderRadius: "6px",
                  minHeight: "40px" // حجم زر رشيق ومريح
                }}
              >
                {/* أيقونة بحجم أصغر وأكثر دقة */}
                <i className={`bi ${item.icon} ms-3 fs-6 ${isActive ? "text-info glow-icon" : ""}`}></i>

                <span className={`fw-medium ${isActive ? "text-white" : ""}`} style={{ fontSize: "0.85rem" }}>
                  {item.label}
                </span>

                {/* مؤشر جانبي نحيف جداً وأنيق */}
                {isActive && (
                  <div
                    className="position-absolute end-0 bg-info"
                    style={{
                      width: "3px",
                      height: "50%",
                      borderRadius: "3px 0 0 3px",
                      boxShadow: "0 0 8px #0dcaf0"
                    }}
                  ></div>
                )}
              </Link>
            </li>
          );
        })}
      </ul>

      <style>{`
        /* تقليل كثافة الخلفية النشطة */
        .active-link {
          background-color: rgba(13, 202, 240, 0.12) !important;
          opacity: 1 !important;
        }

        .glow-icon {
          color: #0dcaf0 !important;
          text-shadow: 0 0 5px rgba(13, 202, 240, 0.5);
        }

        .custom-hover:hover:not(.active-link) {
          background-color: rgba(255, 255, 255, 0.04);
          opacity: 0.9 !important;
        }

        /* سكرول بار أنحف */
        div::-webkit-scrollbar { width: 3px; }
        div::-webkit-scrollbar-thumb { background: #444; }
      `}</style>
    </div>
  );
};

export default Sidebar;